import { ActionIcon } from "@mantine/core";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react";

interface StepNavigationButtonProps {
  direction: "previous" | "next";
  onClick: () => void;
  disabled?: boolean;
}

export function StepNavigationButton({
  direction,
  disabled = false,
  onClick
}: StepNavigationButtonProps) {
  const isPrevious = direction === "previous";

  const color = isPrevious
    ? "var(--mantine-color-neutral-3)"
    : "var(--mantine-primary-color-filled)";
  const iconColor = disabled
    ? "var(--mantine-color-neutral-3)"
    : isPrevious
      ? "var(--mantine-primary-color-filled)"
      : "white";
  const ariaLabel = isPrevious ? "Zurück" : "Weiter";

  return (
    <ActionIcon
      aria-label={ariaLabel}
      className="StepNavigationButton"
      color={color}
      disabled={disabled}
      size={"lg"}
      variant={isPrevious ? "outline" : "filled"}
      onClick={onClick}
    >
      {isPrevious ? (
        <IconArrowLeft color={iconColor} />
      ) : (
        <IconArrowRight color={iconColor} />
      )}
    </ActionIcon>
  );
}
